import type { LabelContent, LabelSize } from "@hisense/shared";
import { printHtml } from "./printWindow";
import { buildLabelDocument } from "./labelDocument";

/**
 * In tem nhiệt CLabel CT321D — MỘT đường duy nhất: dựng một trang đúng khổ tem
 * rồi mở hộp thoại in của hệ điều hành.
 *
 * 20/09/2026 — anh Toàn cho biết máy của Hisense CHỈ CÓ USB, và chốt "làm cách
 * đơn giản nhất và không sai nhất". Đường WebUSB (`mode: 'usb'`) đã bị XOÁ. Mã
 * cũ xem bằng `git show c156b5a:apps/web/src/lib/labelPrinter.ts`.
 *
 * Vì sao xoá chứ không để đó cho người dùng tự chọn:
 *
 * 1. MÁY CHỈ CÓ USB nghĩa là phải cài driver cho đường hộp thoại chạy. Trên
 *    Windows, WebUSB chỉ chạm được thiết bị gắn với driver WinUSB — driver in
 *    của hãng giữ máy thì Chrome không claim được. Hai đường LOẠI TRỪ nhau chứ
 *    không cộng thêm.
 * 2. Đường USB chỉ có trên Chrome/Edge, nên hai nhân viên dùng hai trình duyệt
 *    khác nhau thấy hai màn hình khác nhau.
 * 3. Tệ nhất: font trong máy in chỉ có ASCII, nên tem CÓ tiếng Việt thì tự rơi
 *    về hộp thoại, tem toàn chữ ASCII thì đi đường USB. Cùng một nút, cùng một
 *    lựa chọn, mà hành vi đổi theo việc mô tả sản phẩm tình cờ có dấu hay
 *    không — người dùng không thể đoán, và khi hỏng thì không biết vì sao.
 * 4. Đường USB CHƯA TỪNG chạy với CT321D thật, nên nó chưa bao giờ là thứ đáng
 *    tin để đặt cạnh một đường đã chạy được.
 *
 * Phần dựng lệnh TSPL vẫn còn trong `packages/shared/src/label.ts` cho bàn thử
 * ở tab Kiểm thiết bị — chỉ đường truyền qua USB ở trình duyệt là bỏ.
 *
 * Nếu sau này Hisense mua máy có cổng mạng: KHÔNG khôi phục WebUSB. Đường đúng
 * là bắn TSPL vào cổng 9100 qua một dịch vụ in nhỏ chạy trong mạng kho — in im
 * lặng, không driver, và in được từ điện thoại ở màn Quét theo việc.
 */
export function printLabel(size: LabelSize, content: LabelContent): void {
  printHtml(buildLabelDocument(size, [content]));
}
